import React from 'react';
import './index.css';
import { ListGroup, ListGroupItem } from 'reactstrap';
import { Link } from 'react-router-dom'

const Komisione = ({ bill }) => {

    return (
        <ListGroup>
            {bill.StruktureBill.map(str => <ListGroupItem><Link to={"/struktura/" + str.StrukturaID}  >{str.Struktura.Emri}</Link></ListGroupItem>)}


        </ListGroup>
    );
};

Komisione.propTypes = {

};

export default Komisione;
